import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { authSelector } from '@/stores/auth/authSlice'
import { Outlet, Navigate } from 'react-router-dom'
import config, { APP_MODE } from '@/config'

const PublicRouteMiddleware = () => {
  const { isAuthenticated } = useSelector(authSelector)
  const isProduction = config.mode == APP_MODE.PRODUCTION

  if (isAuthenticated && !isProduction) {
    //Redirect to home to decide what page to redirect
    return <Navigate to="/external/RFQs" />
  } else if (isAuthenticated && isProduction) {
    return <Navigate to="/RFQs" />
  }

  return (
    <div>
      <Outlet />
    </div>
  )
}

export default PublicRouteMiddleware
